import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UrlSettingsCore } from "src/app/core/configuration/url-settings-core";
import { ViewManagerService } from "src/app/core/services/view-manager-service";
import { pdaRegistryConst } from "./constants/registry-const";
import { questions } from "./consultazione-form-config";
import { FormFieldBase } from "src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import { FormFieldControlService } from "src/app/common/components/dynamic-form-field/components/dynamic-form-light/services/dynamic-form-field-control.service";
import { SearchRequest } from "./models/searchRequest";
import { customValidator } from "./validators/consultation-form-validator";
import { DialogService } from "src/app/core/components/dialog/dialog.service";
import { CreazionePraticaStepperComponent } from "src/app/pratica/components/wizard-creazione/components/creazione-pratica-stepper/creazione-pratica-stepper.component";
import { ElaborationDocumentFilterEntity } from "src/app/document-management/models/elaboration-doc-filter";
import { DocumentAssModalComponent } from "src/app/document-management/components/modals/document-ass-modal/document-ass-modal.component";
import { concat, Subject, takeUntil } from "rxjs";
import { ELABORATION_ASS_ACTIONS } from "src/app/document-management/models/elaboration-ass-actions";
import { CreazionePraticaStoreService } from "src/app/pratica/components/wizard-creazione/services/creazione-pratica-store.service";
import { createEntity, createParteEntity } from "./consultation-mapper-utils";
import { Consultation } from "./models/consultation";
import { ConsultationService } from "../section-registry/service/consultation.service";
import { filter, map, tap } from "rxjs";
import { OperationsService } from "src/app/core/services/operations.service";
import { roles } from "./constants/role-const";
import { QuestionControlService } from "src/app/core/components/dynamic-form/services/question-control.service";
import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";
import { ConfirmModalComponent } from "src/app/core/components/dialog/components/confirm-modal/confirm-modal.component";
import { PropertiesSettings } from "src/app/core/configuration/properties-settings";
import { PdaAccessToken, PdaAuthService } from "../../utils/Service/pda-auth.service";
import { SectionsServiceTsService } from "../../utils/Service/sections.service.ts.service";

@Component({
  selector: "app-consultazione",
  templateUrl: "./consultazione.component.html",
  styleUrls: ["./consultazione.component.css"],
  host: { "[attr.id]": "'content'" },
})
export class ConsultazioneComponent implements OnInit {
  urlCancelleria: string =
    "/" + UrlSettingsCore.URL_CANCELLERIA_TELEMATICA + "/";
  form: FormGroup = new FormGroup({});
  registry = pdaRegistryConst;
  roles = roles;
  autoritaGiudiziariaSedeAutorita: any[] = [];
  delegations: any[] = [];
  questions: FormFieldBase[] = [];

  private componentDestroyed$: Subject<void> = new Subject<void>();
  // searchEnabled: boolean = false;

  request: SearchRequest = {};
  consultations: Consultation[] = [];

  hasSearched: boolean = false;

  constructor(
    private viewManager: ViewManagerService,
    private qcs: QuestionControlService,
    private consultationService: ConsultationService,
    private operationService: OperationsService,
    private dialogService: DialogService,
    private creazionePraticaStore: CreazionePraticaStoreService,
    private sectionService: SectionsServiceTsService,
    private pdaAuthService: PdaAuthService
  ) {}

  ngOnInit(): void {
    this.registry = this.registry.sort((a, b) => (a.label.localeCompare(b.label)));
    this.roles = this.roles.sort((a, b) => (a.label.localeCompare(b.label)));
    this.viewManager.svuotaMenu();
    this.populateSelect();
  }
 
  async populateSelect(){
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    const deleghe$ = this.sectionService.getDelegheRicevute({token: token})
      .pipe(
        tap((res) => {
          if(res.deleghe && res.deleghe.length > 0){
            res.deleghe.forEach((r) => {
              let delega = {value: r.codiceFiscale, label: isNaN(r.codiceFiscale) ? r.nome + " " + r.cognome : r.cognome };
            this.delegations.push(delega);
            });
          }
        })
      );
    const anagrafiche$ = this.operationService
      .getAnagraficaAllElementsAttivi("autoritagiudiziariasedeautorita")
      .pipe(
        map((res) =>
          res.anagrafiche.filter(
            (anagrafica) => anagrafica.codiceUfficio != null
          )
        ),
        map((filteredAnagrafiche: any) => {
          filteredAnagrafiche = filteredAnagrafiche.filter((anagrafica) => anagrafica.autoritaGiudiziaria.label != "T.A.R.");
          return filteredAnagrafiche.map((anagrafica) => ({
            label:
              anagrafica.autoritaGiudiziaria.label +
              " - " +
              anagrafica.sedeTerritoriale.label,
            value: anagrafica.codiceUfficio,
          }));
        }),
        tap((res) => (this.autoritaGiudiziariaSedeAutorita = res))
      );
      concat(deleghe$, anagrafiche$)
      .subscribe(() => {
        this.questions = questions;
        this.questions.find(
          (question) => question.key === "officeCode"
        ).options = this.autoritaGiudiziariaSedeAutorita;
        this.questions.find(
          (question) => question.key == "cfDelegante"
        ).options = this.delegations;
        this.autoritaGiudiziariaSedeAutorita = this.autoritaGiudiziariaSedeAutorita.sort((a,b) => (a.label.localeCompare(b.label)));
        // this.form = this.formFieldControlService.toFormGroup(this.questions, this.form);
        this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
        this.form.setValidators(customValidator());
      });
  }

  onReset() {
    this.form.reset();
  }

  async onSearch() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    let rawForm = this.form.getRawValue();
    this.request.registro = rawForm["registry"];
    this.request.ruoloUtente = rawForm["role"];
    this.request.ruoloVisibilita = rawForm["role"];
    this.request.idRuoloJPW = rawForm["role"];
    this.request.parte = rawForm["party"];
    this.request.giudice = rawForm["judge"];
    this.request.dataIscrizioneDal = rawForm["registrationStartDate"];
    this.request.dataIscrizioneAl = rawForm["registrationEndDate"];
    this.request.dataUdienzaDal = rawForm["hearingStartDate"];
    this.request.dataUdienzaAl = rawForm["hearingEndDate"];
    this.request.codiceUfficio = rawForm["officeCode"];
    if(rawForm["cfDelegante"]) this.request.cfDelegante = rawForm["cfDelegante"];
    this.request.token = token;
    this.consultationService
      .searchConsultation(this.request)
      .pipe(
        tap((res) => {
          this.hasSearched = true;
          let consultationTemp = res.fascicoliInfo;
          consultationTemp.map(
            (elem) => (elem.numeroRuolo = +elem.numeroRuolo)
          );
          this.consultations = consultationTemp;
        })
      )
      .subscribe();
  }

  createPractice(consultation) {
    this.consultationMapper(consultation);
    this.creazionePraticaStore.setEntities(
      this.consultationMapper(consultation)
    );
    this.creazionePraticaStore.setCodiceRegistro(this.request.registro)
    {
      const ref = this.dialogService.open(DocumentAssModalComponent, {
        data: {
          style: {
            width: "60%",
          },
          title: "Crea fascicolo",
          annoRuolo: consultation.annoRuolo ? consultation.annoRuolo : null,
          numeroRuolo: consultation.numeroRuolo
            ? +consultation.numeroRuolo
            : null,
          source: "PDA",
        },
      });
      ref.afterClosed
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe((res) => {
          if (res?.closeEvent) {
            this.onExitEvent();
          } else {
            if (res && res.hasOwnProperty("action")) {
              this.switchActions(res.action, res);
            }
          }
        });
    }
  }

  needsAdditionalInfo(): boolean{
    return this.form.invalid &&
      (!this.form.controls['party'].value
      && !this.form.controls['judge'].value
      && !this.form.controls['registrationStartDate'].value
      && !this.form.controls['registrationEndDate'].value
      && !this.form.controls['hearingStartDate'].value
      && !this.form.controls['hearingEndDate'].value);
  }

  private switchActions(action: any, res: any = null) {
    switch (action) {
      case ELABORATION_ASS_ACTIONS.CREA_PRATICA: {
        const refCrPratica = this.dialogService.open(
          CreazionePraticaStepperComponent,
          {
            data: {
              style: { width: "70%" },
              title: "Aggiungi nuova pratica",
              idElaborazione: "new",
            },
          }
        );
        refCrPratica.afterClosed
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe((data) => {
            if (data?.closeEvent) {
              this.onExitEvent();
            } else {
              if (data && data.fascicoloTempDeleted) {
                if(data.fascicoloCreato) {
                  this.aggiornaNotifiche();
                  this.openCompletionModal(data.fascicoloCreato.posizione);
                }
                this.onExitEvent();
              } if(data && !data.fascicoloTempDeleted){
                  this.onExitEvent();
              }
            }
          });
        break;
      }
      case ELABORATION_ASS_ACTIONS.CREA_FASCICOLO: {
        const refCrFascicolo = this.dialogService.open(
          CreazionePraticaStepperComponent,
          {
            data: {
              style: { width: "70%" },
              title: "Aggiungi nuovo fascicolo",
              idElaborazione: "new",
              idPratica: res.idPratica,
              tipoPratica: res.tipoPratica,
            },
          }
        );
        refCrFascicolo.afterClosed
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe((data) => {
            if (data?.closeEvent) {
              this.onExitEvent();
            } else {
              if (data && data.fascicoloTempDeleted) {
                if (data.fascicoloCreato) {
                  this.aggiornaNotifiche();
                  this.openCompletionModal(data.fascicoloCreato.posizione);
                }
                this.onExitEvent();
              } if (data && !data.fascicoloTempDeleted) {
                this.onExitEvent();
              }
            }
          });
        break;
      }
    }
  }

  private consultationMapper(
    consultation: any
  ): ElaborationDocumentFilterEntity[] {
    let elaborationDocumentFilterEntity: ElaborationDocumentFilterEntity[] = [];
    for (let chiave of Object.keys(consultation)) {
      if (chiave === "idUfficio") {
        elaborationDocumentFilterEntity.push(
          this.retrieveAutority(consultation[chiave])
        );
      } else if (consultation[chiave] instanceof Array) {
        for (let value of consultation[chiave]) {
          elaborationDocumentFilterEntity.push(
            ...createParteEntity(chiave, value)
          );
        }
      } else if (consultation[chiave]) {
        elaborationDocumentFilterEntity.push(
          createEntity(chiave, consultation[chiave])
        );
      }
    }
    if (consultation.numeroRuolo && consultation.annoRuolo) {
      elaborationDocumentFilterEntity.push(
        this.formatEntitityYearAndRoleNumber(
          consultation.numeroRuolo,
          consultation.annoRuolo
        )
      );
    }
    return elaborationDocumentFilterEntity;
  }

  private formatEntitityYearAndRoleNumber(
    numeroRuolo: string,
    annoRuolo: string
  ): ElaborationDocumentFilterEntity {
    let entity: ElaborationDocumentFilterEntity = {
      uri: "",
      valore: numeroRuolo + "/" + annoRuolo,
      tipoEntita: {
        label_key: "case_number",
        tipo: "metadata",
        id: " ",
        rimosso: false,
        descrizione: " ",
        label: " ",
      },
    };
    return entity;
  }

  private retrieveAutority(
    codiceUfficio: string
  ): ElaborationDocumentFilterEntity {
    let autority: string = this.autoritaGiudiziariaSedeAutorita.find(
      (elem) => elem.value === codiceUfficio
    ).label;
    let autorityInfoArray = autority.split(' - ');
    let autoritaGiudiziaria = "";
    for (let index = 0; index < autorityInfoArray.length - 1; index++) {
      if(index === 0){
        autoritaGiudiziaria = autorityInfoArray[index]
      } else {
        autoritaGiudiziaria += " - " + autorityInfoArray[index]
      }
    }
    let sede = autorityInfoArray[autorityInfoArray.length-1]

    let entity: ElaborationDocumentFilterEntity = {
      uri: "",
      valore: autoritaGiudiziaria  + (sede ? " sede: " + sede: ""),
      tipoEntita: {
        label_key: "court",
        tipo: "metadata",
        id: " ",
        rimosso: false,
        descrizione: " ",
        label: " ",
      },
    };
    return entity;
  }

  onExitEvent() {
    this.creazionePraticaStore.fromWizard = false;
    this.creazionePraticaStore.deleteAll();
  }

  openCompletionModal(posizione: string) {
    return this.dialogService.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text:
            "Completamento del fascicolo " +
            posizione +
            " avvenuto con successo.",
          data: [],
          hideButtons: true,
        },
        style: {
          width: "30%",
        },
        title: PropertiesSettings.MSG_GENERIC_SUCCESS,
      },
    });
  }

  aggiornaNotifiche() {
    this.operationService
      .getProssimiAdempimenti({ fromResult: 0 }).subscribe((response) =>
        this.viewManager._prossimiAdempimenti.next({param: response, timeOut: false,})
      );
    this.operationService
      .getAdempimentiInevasi({ fromResult: 0 }).subscribe((response) =>
        this.viewManager._adempimentiInevasi.next({param: response,timeOut: false,})
      );
    this.operationService
      .prendiNotificheAttivitaPaginate({ fromResult: 0 }).subscribe((response) => {
        this.viewManager._refreshNotifiche.next({param: response,timeOut: false,});
        this.operationService.prendiAttivitaCompletarePaginate({ fromResult: 0 }).subscribe((response) => {
            this.viewManager._refreshAttivitaCompletare.next({param: response,timeOut: false,});
          });
      });
  }
}
